import clsx from "clsx";

const sizes = {
  sm: "size-4",
  md: "size-6",
  lg: "size-10",
};

export function LoadingSpinner({
  className,
  size = "md",
}: {
  className?: string;
  size?: keyof typeof sizes;
}) {
  return (
    <div role="status">
      <svg
        aria-hidden="true"
        className={clsx(sizes[size], "animate-spin", className)}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          opacity="0.3"
          cx="11"
          cy="11"
          r="9.5"
          stroke="currentColor"
          stroke-width={3}
        />
        <path
          d="M20.5 11.5C20.5 10.1868 20.2672 8.88642 19.8149 7.67317C19.3626 6.45991 18.6997 5.35752 17.864 4.42893C17.0282 3.50035 16.0361 2.76375 14.9442 2.2612C13.8522 1.75866 12.6819 1.5 11.5 1.5"
          stroke="currentColor"
          stroke-width={3}
          stroke-linecap="round"
        />
      </svg>
      <span className="sr-only">Loading...</span>
    </div>
  );
}
